import { Grid, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import QCXFinalField from '../../../../../shared-components/final-field/QCXFinalField';
import QCXFinalTextField from '../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalMultilineInputWithChips from '../../transferencia-lote/TransferenciaLoteManagerPage/QCXFinalMultilineInputWIthChips';

export default function FollowUpAdvancedFilterForm() {
    const { t } = useTranslation();

    return (
        <Box style={{ minWidth: '500px' }}>
            <Grid container spacing={2}>
                <Grid item sm={6}>
                    <QCXFinalTextField
                        id="text-field-vinculo-referencia-cliente"
                        key="text-field-vinculo-referencia-cliente"
                        name="referencia"
                        label={t('com.muralis.qcx.referenciaCliente')}
                        maxLength={100}
                    />
                </Grid>
                <Grid item sm={6}>
                    <QCXFinalTextField
                        id="text-field-numero-conhecimento-master"
                        key="text-field-numero-conhecimento-master"
                        name="numeroConhecimentoMaster"
                        label={t('com.muralis.qcx.numeroConhecimentoMaster')}
                        maxLength={18}
                    />
                </Grid>
                <Grid item sm={6}>
                    <QCXFinalTextField
                        id="text-field-numero-conhecimento-house"
                        key="text-field-numero-conhecimento-house"
                        name="numeroConhecimentoHouse"
                        label={t('com.muralis.qcx.numeroConhecimentoHouse')}
                        maxLength={18}
                    />
                </Grid>
                <Grid item sm={6}>
                    <QCXFinalTextField
                        id="text-field-numero-documento-despacho"
                        key="text-field-numero-documento-despacho"
                        name="numeroFaturaComercial"
                        label="Número Instrução Despacho"
                        maxLength={24}
                    />
                </Grid>
                <Grid item sm={12}>
                    <QCXFinalMultilineInputWithChips
                        name="diDuimp"
                        label="DI/DUIMP"
                    />
                </Grid>
                <Grid item sm={12}>
                    <QCXFinalMultilineInputWithChips
                        name="numeroContainer"
                        label="NNumeração Container"
                    />
                </Grid>
            </Grid>
        </Box >
    );
}
